import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import { GET_ALL_EVENT_GROUPS } from "./actionTypes";
import { getAllEventGroupsApi } from "api/eventGroups";

import { getAllEventGroupsFailure, getAllEventGroupsSuccess } from "./actions";

function* getAllEventGroups({ payload }) {
  try {
    const { data } = yield call(getAllEventGroupsApi, payload);
    yield put(getAllEventGroupsSuccess(data));
  } catch (error) {
    yield put(getAllEventGroupsFailure(error.response.data || error));
  }
}

export function* watchGetAllEventGroups() {
  yield takeEvery(GET_ALL_EVENT_GROUPS, getAllEventGroups);
}

function* eventGroupsSaga() {
  yield all([fork(watchGetAllEventGroups)]);
}

export default eventGroupsSaga;
